// extracted by mini-css-extract-plugin
export var footerSocialItem = "social-medias-module--footer-social-item--ab106";
export var footerSocialLinks = "social-medias-module--footer-social-links--be03a";